import {
  BetProductWithSportsbook,
  NFLMismatch,
  BettingNFLEvent,
  NFLPlayerWithGrade,
  PlayerProp,
  NFLTeam,
  FantasyTag,
  NFLTeamRanking,
  PlayerPropKey,
  SDKPlayerProp,
  BetStatus,
  BetOptionType,
} from '@pff-consumer/schema'
import { TEAM_CONFERENCE_DIVISION_INFO } from '@pff-consumer/utils'
import { times } from 'lodash'
import { chance } from 'jest-chance'
import { User } from './lib/account/mocks/user'

const mockGames: BettingNFLEvent[] = []
const mockMismatchs: NFLMismatch[] = []
const mockPlayers: NFLPlayerWithGrade[] = []
const mockPropBets: PlayerProp[] = []
const mockBestBets: PlayerProp[] = []
const mockPropBetsWithPlayer: SDKPlayerProp[] = []
const mockFDPropBetsWithPlayer: SDKPlayerProp[] = []
const mockTeams: NFLTeam[] = []
const mockBets: BetProductWithSportsbook[] = []
const mockTeamGrading: NFLTeamRanking[] = [
  {
    teamId: 2,
    quarterbackName: 'Home QB',
    quarterbackRank: 1,
    offensiveLineRank: 11,
    defensiveLineRank: 21,
    receiverRank: 31,
    coverageRank: 7,
    gameId: 2,
    quarterbackPlayerId: 4,
    runningBackRank: 20,
  },
  {
    teamId: 1,
    quarterbackName: 'Away QB',
    quarterbackRank: 32,
    offensiveLineRank: 2,
    defensiveLineRank: 28,
    receiverRank: 25,
    coverageRank: 14,
    gameId: 2,
    quarterbackPlayerId: 5,
    runningBackRank: 10,
  },
]

let gameId = 1

const getNextGameId = () => {
  gameId += 1
  return gameId
}

export const defaultBetProductData: BetProductWithSportsbook = {
  value: 1,
  odds: -110,
  description: 'This bet was mocked.',
  sportsbookId: 'BETMGM',
  sportsbookBetId: 'MOCKED_SPORTSBOOK_BET_ID',
  sportsbookEventId: 'MOCKED_SPORTSBOOK_EVENT_ID',
  updatedTimestamp: Date.now(),
  gameId: 2,
  // type should be one of TypeOfBet
  detailedType: chance.pickone([
    'AwayTeamMoneyline',
    'AwayTeamSpread',
    'HomeTeamMoneyline',
    'HomeTeamSpread',
    'Player',
    'Over',
    'Under',
  ]),
  generalType: chance.pickone(['Spread', 'Moneyline', 'Total']),
  category: chance.pickone(['Game Bet', 'Mismatches Prop', 'General Player Prop']),
  sportsbookMarketId: 'MOCKED_SPORTSBOOK_MARKET_ID',
  sportsbookOptionId: 'MOCKED_SPORTSBOOK_OPTION_ID',
  status: chance.pickone(['winner', 'loser', 'void', undefined]),
  uniqueBetId: 'MOCKED_SPORTSBOOK_UNIQUE_ID',
}

times(10, (i: number) => {
  times(10, (n) => {
    const mockGameId = getNextGameId()
    // @ts-expect-error
    mockGames.push({
      league: 'nfl',
      weekAbv: i.toString(),
      gameId: mockGameId,
      eventId: mockGameId,
      sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
      season: 2022,
      awayTeamId: 1,
      homeTeamId: 2,
      eventStatus: 'Scheduled',
      homeScore: 21,
      awayScore: 7,
      channel: 'NBC',
      startTimestamp: new Date(`Sept ${(i + 1) * 3 + Math.floor(n / 5)} 2022 19:30`).getTime(),
      homeMoneyline: {
        ...defaultBetProductData,
        sportsbookBetId: chance.guid(),
        detailedType: 'HomeTeamMoneyline',
        generalType: 'Moneyline',
      },
      awayMoneyline: {
        ...defaultBetProductData,
        sportsbookBetId: chance.guid(),
        detailedType: 'AwayTeamMoneyline',
        generalType: 'Moneyline',
        category: 'Game Bet',
      },
      homePointSpread: {
        ...defaultBetProductData,
        sportsbookBetId: chance.guid(),
        detailedType: 'HomeTeamSpread',
        generalType: 'Spread',
        category: 'Game Bet',
      },
      awayPointSpread: {
        ...defaultBetProductData,
        sportsbookBetId: chance.guid(),
        detailedType: 'AwayTeamSpread',
        generalType: 'Spread',
        category: 'Game Bet',
      },
      overTotal: {
        ...defaultBetProductData,
        sportsbookBetId: chance.guid(),
        detailedType: 'Over',
        generalType: 'Total',
        category: 'Game Bet',
      },
      underTotal: {
        ...defaultBetProductData,
        sportsbookBetId: chance.guid(),
        detailedType: 'Under',
        generalType: 'Total',
        category: 'Game Bet',
      },
    })
  })
})

times(15, (i) => {
  mockPlayers.push({
    playerId: chance.integer({ min: 0 }),
    firstName: chance.first(),
    lastName: chance.last(),
    position: chance.pickone(['QB', 'RB', 'WR', 'TE', 'K']),
    draftTeamId: chance.integer({ min: 0 }),
    draftSeason: chance.integer({ min: 0 }),
    draftRound: chance.integer({ min: 0 }),
    draftSelection: chance.integer({ min: 0 }),
    hometownId: chance.integer({ min: 0 }),
    collegeId: chance.integer({ min: 0 }),
    teamId: i + 1,
    height: chance.integer({ min: 0, max: 100 }),
    weight: chance.integer({ min: 100, max: 400 }),
    jerseyNumber: chance.integer({ min: 1, max: 99 }),
    birthDate: chance.date().toISOString(),
    speed: chance.integer({ min: 0, max: 100 }),
    byeWeek: chance.integer({ min: 0, max: 17 }),
    adp: chance.natural(),
    adpPosition: chance.natural(),
    projection: {
      points: {
        low: chance.floating({ min: 0, max: 200 }),
        mid: chance.floating({ min: 0, max: 200 }),
        high: chance.floating({ min: 0, max: 200 }),
      },
      position: {
        low: chance.floating({ min: 0, max: 200 }),
        mid: chance.floating({ min: 0, max: 200 }),
        high: chance.floating({ min: 0, max: 200 }),
      },
    },
    grade: {
      rank: chance.integer({ min: 1, max: 100 }),
      value: chance.floating({ min: 20, max: 100 }),
    },
    tags: chance.pickset(
      [FantasyTag.BREAKOUT, FantasyTag.BUST, FantasyTag.PFF_VALUE, FantasyTag.SLEEPER, FantasyTag.ROOKIE],
      chance.integer({ min: 0, max: 5 })
    ),
  })
})

const propBetTypeswithOverAndUnder: PlayerPropKey[] = [
  'rush_att',
  'rush_yd',
  'rush_recv_yd',
  'pass_comp',
  'pass_int',
  'pass_att',
  'pass_yd',
  'pass_td',
  'recv_yd',
  'recv_rec',
  'pass_rush_yd',
]

const propBetTypeswithOnlyOver: PlayerPropKey[] = ['alt_pass_yd', 'alt_rush_yd', 'alt_recv_yd']

const propBetTypesWithoutOverOrUnder: PlayerPropKey[] = [
  'any_time_td',
  'first_td',
  'two_plus_td',
  'three_plus_td',
  'most_pass_yd',
  'most_rush_yd',
  'first_team_td_scorer',
  'first_td_second_half',
  'last_td',
  'first_half_td',
  'second_half_td',
  'first_completion',
  'longest_pass',
  'longest_reception',
  'first_reception',
  'longest_rush',
  'first_rush_att',
]

propBetTypeswithOverAndUnder.forEach((propKey, ix) => {
  const player = mockPlayers[ix]
  const sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId,
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'BETMGM',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey,
    gameId: 2,
    edge: chance.integer({ min: 1.0, max: 4.0 }),
  }

  mockPropBetsWithPlayer.push({
    ...sharedPropData,
    odds: chance.integer({ min: -200, max: 200 }),
    option: 'over',
    sportsradarId: `${chance.integer({ min: 1, max: 10000 })}`,
    sportsbookOptionId: `${chance.integer({ min: 1, max: 10000 })}`,
    analysisText: 'MOCKED ANALYSIS TEXT',
  })

  mockPropBetsWithPlayer.push({
    ...sharedPropData,
    odds: chance.integer({ min: -200, max: 200 }),
    option: 'under',
    sportsradarId: `${chance.integer({ min: 1, max: 10000 })}`,
    sportsbookOptionId: `${chance.integer({ min: 1, max: 10000 })}`,
    analysisText: 'MOCKED ANALYSIS TEXT',
  })
})

times(10, () => {
  const propBet: PlayerProp = {
    playerId: chance.integer({ min: 0 }),
    name: 'MOCKED PROP BET',
    sportsbookId: 'BETMGM',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    odds: chance.integer({ min: -200, max: 200 }),
    grade: chance.pickone(['A', 'B', 'C', 'D', 'F']),
    propKey: chance.pickone(propBetTypeswithOverAndUnder),
    option: chance.pickone(['over', 'under']),
    gameId: 2,
    edge: chance.floating({ min: 1.0, max: 4.0 }),
  }

  mockPropBets.push(propBet)

  // mock data for best bets should have grade as 'A'
  mockBestBets.push({ ...propBet, grade: 'A', edge: chance.floating({ min: 2.6, max: 4.0 }) })
})

times(10, (i) => {
  mockMismatchs.push({
    id: chance.string(),
    gameId: chance.integer({ min: 0 }),
    offenseHomeTeam: chance.bool(),
    homeTeamId: chance.integer({ min: 0 }),
    awayTeamId: chance.integer({ min: 0 }),
    mismatchType: chance.pickone(['LWR_RCB', 'RWR_LCB', 'SWR_SCB', 'WR_DB', 'HB_LB', 'TE_LB']),
    offensePlayerIds: [chance.integer({ min: 0 })],
    defensePlayerIds: [chance.integer({ min: 0 })],
    description: chance.sentence({ words: 3 }),
    spread: (3 - i * 0.3) * chance.pickone([-1, 1]),
    gradeDifference: chance.floating({ min: 0, max: 50 }),
    active: true,
    bets: mockPropBetsWithPlayer,
    insight: 'test insight',
  })
})

times(10, (i) => {
  mockTeams.push({
    teamId: i + 1,
    teamAbv: Object.keys(TEAM_CONFERENCE_DIVISION_INFO)[i],
    name: i === 0 ? 'Dolphins' : chance.name(),
    city: chance.city(),
    byeWeek: chance.integer({ min: 4, max: 15 }),
    fullName: i === 0 ? 'Miami Dolphins' : chance.name(),
    headCoach: chance.name(),
    colors: [chance.string()],
    stadiumDetails: {
      name: chance.name(),
      city: chance.city(),
      state: chance.state(),
      country: chance.country(),
      capacity: chance.integer({ min: 0 }),
      stadiumType: chance.pickone(['Outdoor', 'Dome', 'RetractableDome']),
    },
    season: chance.integer({ min: 2000, max: 2050 }),
    league: 'nfl',
    conference: chance.pickone(['AFC', 'NFC']),
    division: chance.pickone(['North', 'East', 'West', 'South']),
  })
})
times(10, (i) => {
  mockBets.push({
    ...defaultBetProductData,
    sportsbookBetId: `id${i + 1}`,
  })
})

// Mocking data for FD player props.
propBetTypeswithOverAndUnder.forEach((propKey, ix) => {
  const player = mockPlayers[ix]
  const sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId,
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'FD',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey,
    gameId: 2,
  }

  mockFDPropBetsWithPlayer.push({
    ...sharedPropData,
    odds: -200,
    option: 'over',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT',
  })

  mockFDPropBetsWithPlayer.push({
    ...sharedPropData,
    odds: +200,
    option: 'under',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT',
  })
})

propBetTypeswithOnlyOver.forEach((propKey, ix) => {
  const player = mockPlayers[ix]
  const sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId,
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'FD',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey,
    gameId: 2,
  }

  mockFDPropBetsWithPlayer.push({
    ...sharedPropData,
    odds: -110,
    option: 'over',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT',
  })
})

propBetTypesWithoutOverOrUnder.forEach((propKey, ix) => {
  const player = mockPlayers[ix % 15]
  const sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId,
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'FD',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey,
    gameId: 2,
  }

  mockFDPropBetsWithPlayer.push({
    ...sharedPropData,
    odds: -200,
    option: 'over',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT',
  })
})

export const mockData = {
  games: mockGames,
  mismatches: mockMismatchs,
  players: mockPlayers,
  propBets: mockPropBets,
  bestBets: mockBestBets,
  propBetsWithPlayer: mockPropBetsWithPlayer,
  teams: mockTeams,
  bets: mockBets,
  teamGrading: mockTeamGrading,
  user: User,
}
export const mockDataForFDPlayerProps = {
  propBetsWithPlayer: mockFDPropBetsWithPlayer,
}
export const MOCK_ERROR_ID = 999999999
export const MOCK_EMPTY_ID = 101010101

export const mockCurrentWeek = {
  weekType: 'POST',
  abbreviation: 'WC',
  description: 'Wild Card',
}

export const mockEventByCurrentWeekWithScore = {
  season: 2022,
  week: 'WC',
  events: [
    {
      eventId: 23637,
      eventStatus: 'Final',
      startTimestamp: 1673731800000,
      sportradarId: 'f5b7bedd-ad2b-4304-8861-ef778c7348be',
      sportsbookEventId: '32014055',
      weekAbv: 'WC',
      homeTeam: '49ers',
      awayTeam: 'Seahawks',
      homeTeamId: 28,
      awayTeamId: 29,
      homeTeamAbbreviation: 'SF',
      awayTeamAbbreviation: 'SEA',
      homeScore: 41,
      awayScore: 23,
    },
    {
      eventId: 23641,
      eventStatus: 'Final',
      startTimestamp: 1673831700000,
      sportradarId: 'bef2d032-4f28-4b29-bbaf-b8d3ddb84f5a',
      sportsbookEventId: '32013579',
      weekAbv: 'WC',
      homeTeam: 'Bengals',
      awayTeam: 'Ravens',
      homeTeamId: 7,
      awayTeamId: 3,
      homeTeamAbbreviation: 'CIN',
      awayTeamAbbreviation: 'BAL',
      homeScore: 24,
      awayScore: 17,
    },
    {
      eventId: 23642,
      eventStatus: 'Final',
      startTimestamp: 1673918100000,
      sportradarId: '910a1bd3-3818-46e4-a9dd-de8caf8c70e8',
      sportsbookEventId: '32013698',
      weekAbv: 'WC',
      homeTeam: 'Buccaneers',
      awayTeam: 'Cowboys',
      homeTeamId: 30,
      awayTeamId: 9,
      homeTeamAbbreviation: 'TB',
      awayTeamAbbreviation: 'DAL',
      homeScore: 14,
      awayScore: 31,
    },
    {
      eventId: 23640,
      eventStatus: 'Final',
      startTimestamp: 1673819400000,
      sportradarId: '5a63395a-facd-4098-bf86-63ae39cff218',
      sportsbookEventId: '32013702',
      weekAbv: 'WC',
      homeTeam: 'Vikings',
      awayTeam: 'Giants',
      homeTeamId: 18,
      awayTeamId: 21,
      homeTeamAbbreviation: 'MIN',
      awayTeamAbbreviation: 'NYG',
      homeScore: 24,
      awayScore: 31,
    },
    {
      eventId: 23639,
      eventStatus: 'Final',
      startTimestamp: 1673805600000,
      sportradarId: '741b54b9-0a51-4bb9-a2a2-9543041cfb44',
      sportsbookEventId: '32013584',
      weekAbv: 'WC',
      homeTeam: 'Bills',
      awayTeam: 'Dolphins',
      homeTeamId: 4,
      awayTeamId: 17,
      homeTeamAbbreviation: 'BUF',
      awayTeamAbbreviation: 'MIA',
      homeScore: 34,
      awayScore: 31,
    },
    {
      eventId: 23638,
      eventStatus: 'Final',
      startTimestamp: 1673745300000,
      sportradarId: 'efeba152-4733-4450-9e05-81f2c1e29821',
      sportsbookEventId: '32013582',
      weekAbv: 'WC',
      homeTeam: 'Jaguars',
      awayTeam: 'Chargers',
      homeTeamId: 15,
      awayTeamId: 27,
      homeTeamAbbreviation: 'JAX',
      awayTeamAbbreviation: 'LAC',
      homeScore: 31,
      awayScore: 30,
    },
  ],
}

export const mockEventByIdWithScore = {
  event: {
    season: 2022,
    eventId: 23637,
    eventStatus: 'Final',
    startTimestamp: 1673731800000,
    sportradarId: 'f5b7bedd-ad2b-4304-8861-ef778c7348be',
    sportsbookEventId: '32014055',
    weekAbv: 'WC',
    homeTeam: '49ers',
    awayTeam: 'Seahawks',
    homeTeamId: 28,
    awayTeamId: 29,
    homeTeamAbbreviation: 'SF',
    awayTeamAbbreviation: 'SEA',
    homeScore: 41,
    awayScore: 23,
  },
}

export const mockMarketData = {
  markets: [
    {
      eventId: 23637,
      market: 'moneyline',
      value: null,
      odds: 390,
      option: 'away',
      sportsbookBetId: '32014055-357833258-50213',
      sportsbookEventId: '32014055',
      sportsbookMarketId: '357833258',
      sportsbookOptionId: '50213',
      status: null,
      uniqueBetId: '23637+moneyline+away',
    },
    {
      eventId: 23637,
      market: 'moneyline',
      value: null,
      odds: -510,
      option: 'home',
      sportsbookBetId: '32014055-357833258-43010249',
      sportsbookEventId: '32014055',
      sportsbookMarketId: '357833258',
      sportsbookOptionId: '43010249',
      status: null,
      uniqueBetId: '23637+moneyline+home',
    },
    {
      eventId: 23637,
      market: 'handicap-points',
      value: 9.5,
      odds: -108,
      option: 'away',
      sportsbookBetId: '32014055-357833259-50213',
      sportsbookEventId: '32014055',
      sportsbookMarketId: '357833259',
      sportsbookOptionId: '50213',
      status: null,
      uniqueBetId: '23637+handicap-points+away',
    },
    {
      eventId: 23637,
      market: 'handicap-points',
      value: -9.5,
      odds: -112,
      option: 'home',
      sportsbookBetId: '32014055-357833259-43010249',
      sportsbookEventId: '32014055',
      sportsbookMarketId: '357833259',
      sportsbookOptionId: '43010249',
      status: null,
      uniqueBetId: '23637+handicap-points+home',
    },
    {
      eventId: 23637,
      market: 'total-points',
      value: 42.5,
      odds: -118,
      option: 'under',
      sportsbookBetId: '32014055-357833261-7017917',
      sportsbookEventId: '32014055',
      sportsbookMarketId: '357833261',
      sportsbookOptionId: '7017917',
      status: null,
      uniqueBetId: '23637+total-points+under',
    },
    {
      eventId: 23637,
      market: 'total-points',
      value: 42.5,
      odds: -104,
      option: 'over',
      sportsbookBetId: '32014055-357833261-7017916',
      sportsbookEventId: '32014055',
      sportsbookMarketId: '357833261',
      sportsbookOptionId: '7017916',
      status: null,
      uniqueBetId: '23637+total-points+over',
    },
  ],
}

export const mockPaginatedMarket = 'alt_pass_yd'
export const mockPaginatedWeek = 'SB'
export const mockPaginatedPlayerId = 'SB'

export const mockPaginatedPropBets = {
  nextPage: 2,
  eventId: mockEventByIdWithScore.event.eventId,
  total: 14,
  playerProps: [
    {
      eventId: mockEventByIdWithScore.event.eventId,
      playerId: 40291,
      teamId: 24,
      odds: 640,
      value: 325,
      name: 'jalen hurts 325+ yards alt passing yds',
      option: 'over' as BetOptionType,
      marketType: 'total',
      market: 'alt_pass_yd' as PlayerPropKey,
      sportsbookBetId: '32052129-361532748-40905807',
      sportsbookEventId: '32052129',
      sportsbookMarketId: '361532748',
      sportsbookOptionId: '40905807',
      status: 'winner' as BetStatus,
    },
    {
      eventId: mockEventByIdWithScore.event.eventId,
      playerId: 11765,
      teamId: 16,
      odds: -1450,
      value: 200,
      name: 'patrick mahomes 200+ yards alt passing yds',
      option: 'over' as BetOptionType,
      marketType: 'total',
      market: 'alt_pass_yd' as PlayerPropKey,
      sportsbookBetId: '32052129-361532749-38245772',
      sportsbookEventId: '32052129',
      sportsbookMarketId: '361532749',
      sportsbookOptionId: '38245772',
      status: 'winner' as BetStatus,
    },
    {
      eventId: mockEventByIdWithScore.event.eventId,
      playerId: 11765,
      teamId: 16,
      odds: -650,
      value: 225,
      name: 'patrick mahomes 225+ yards alt passing yds',
      option: 'over' as BetOptionType,
      marketType: 'total',
      market: 'alt_pass_yd' as PlayerPropKey,
      sportsbookBetId: '32052129-361532749-38245774',
      sportsbookEventId: '32052129',
      sportsbookMarketId: '361532749',
      sportsbookOptionId: '38245774',
      status: 'winner' as BetStatus,
    },
    {
      eventId: mockEventByIdWithScore.event.eventId,
      playerId: 11765,
      teamId: 16,
      odds: -320,
      value: 250,
      name: 'patrick mahomes 250+ yards alt passing yds',
      option: 'over' as BetOptionType,
      marketType: 'total',
      market: 'alt_pass_yd' as PlayerPropKey,
      sportsbookBetId: '32052129-361532749-38245771',
      sportsbookEventId: '32052129',
      sportsbookMarketId: '361532749',
      sportsbookOptionId: '38245771',
      status: 'winner' as BetStatus,
    },
    {
      eventId: mockEventByIdWithScore.event.eventId,
      playerId: 11765,
      teamId: 16,
      odds: -174,
      value: 275,
      name: 'patrick mahomes 275+ yards alt passing yds',
      option: 'over' as BetOptionType,
      marketType: 'total',
      market: 'alt_pass_yd' as PlayerPropKey,
      sportsbookBetId: '32052129-361532749-38245770',
      sportsbookEventId: '32052129',
      sportsbookMarketId: '361532749',
      sportsbookOptionId: '38245770',
      status: 'winner' as BetStatus,
    },
  ],
}
